<div class="container-fluid" id="navMatricula">
    <div class="row mb-2" *ngIf="mostrarNoti">
        <div class="col-md-12">
            <div class="row align-items-center">
                <div class="col-md-1 text-center">
                    <i class="fa-solid fa-comments fa-2xl"></i>
                </div>
                <div class="col-md-11">
                    <h5>{{cintillo}}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-md-12">
            <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
            <div class="rounded" style="background-color: var(--app-claro, #53aaed); padding: 0.5em 0;">
                <div class="row align-items-center" style="color: white; text-align: center;">
                    <div class="col-md-2"><i class="fa fa-file-pen fa-2x"></i></div>
                    <div class="col-md-8">
                        <h5 class="mb-0" style="color: white">PROCESO DE PREMATRICULA</h5>
                    </div>
                </div>
            </div>
            <div style="background-color: black; padding: 0.5em 0; color: white;">
                <div class="row align-items-center">
                    <div class="col-md-2 offset-md-8 offset-sm-0 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-calendar"></i> &nbsp; {{ahora | date: 'yyyy/MM/dd' }}
                        </h5>
                    </div>
                    <div class="col-md-2 col-sm-12" style="text-align: right">
                        <h5 class="mb-0" style="color: white; padding-right: 1em;">
                            <i class="fa-regular fa-clock"></i>&nbsp; {{ahora | date: 'hh:mm:ss a' }}
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <ul ngbNav [(activeId)]="activeTab"  (navChange)="onNavChange($event)" #nav="ngbNav" class="nav-tabs">
                <li [ngbNavItem]="1">
                    <a ngbNavLink class="itemTab" 
                        style="clip-path: polygon(0% 0%,80% 0%,100% 50%,80% 100%,0% 100%);">
                        <h5 style="padding-right: 20%">Verifique sus datos personales</h5>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="card mt-2">
                            <div class="card-body">
                                <h4 class="azul"><b>Verifique sus datos</b></h4>
                                <hr class="azul">

                                <div class="row">
                                    <label for="" class="col-md-2"><b>Nombre Completo:</b></label>
                                    <label for="" class="col-md-10">{{datosPersonales.M12NOM}} {{datosPersonales.M12AP1}} {{datosPersonales.M12AP2}}</label>
                                </div>
                                <div class="row">
                                    <label for="" class="col-md-2"><b>Carné:</b></label>
                                    <label for="" class="col-md-10">{{datosPersonales.M12CAR}}</label>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="row">
                                            <label for="" class="col-md-2"><b>Correo:</b></label>
                                            <label for="" class="col-md-10">
                                                <input type="email" [(ngModel)]="datosPersonales.M12EMA" class="form-control">
                                            </label>
                                        </div>
                                        <div class="row">
                                            <label for="" class="col-md-2"><b>Teléfono fijo:</b></label>
                                            <label for="" class="col-md-10">
                                                <input type="text" [(ngModel)]="datosPersonales.M12TEL" class="form-control">
                                            </label>
                                        </div>
                                        <div class="row">
                                            <label for="" class="col-md-2"><b>Celular:</b></label>
                                            <label for="" class="col-md-10">
                                                <input type="text" [(ngModel)]="datosPersonales.M12CEL" class="form-control">
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="row">
                                            <label for="" class="col-md-2"><b>Dirección completa:</b></label>
                                            <label for="" class="col-md-10">
                                                <textarea rows="5" class="form-control" [(ngModel)]="datosPersonales.M12DIR"></textarea>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3" style="text-align: right">
                                    <button type="button" (click)="confirmarDatos()" class="btn btn-sm btn-info">Confirmar datos</button>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <h4 class="azul"><b>Términos y condiciones</b></h4>
                                <hr class="azul">
                                <br>

                                <div class="row">
                                    <div style="height: 150px; background-color: lightgray"></div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="rounded"
                                        style="background-color: gray; padding: 1em; color: white; display: flex;">
                                        <input type="checkbox" style="margin-right: 1em; transform: scale(1.5);"> He
                                        leído y acepto los términos y condiciones para realizar el proceso de
                                        prematricula
                                    </div>
                                </div>
                                <br>
                                <br>
                                <div class="row gx-2" style="text-align: right">
                                    <div class="col-md-2 offset-md-8">
                                        <button type="button" style="width: 100%"
                                            class="btn btn-sm btn-secondary w-100">Cancelar</button>
                                    </div>
                                    <div class="col-md-2">
                                        <button type="button" (click)="tabAdelante()"
                                            class="btn btn-sm btn-info w-100">Continuar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
                <li [ngbNavItem]="2">
                    <a ngbNavLink class="itemTab"
                        style="clip-path: polygon(0% 0%,80% 0%,100% 50%,80% 100%,0% 100%,20% 50%);
                        margin-left:-25%">
                        <h5 style="padding-left: 20%">Seleccionar período de matrícula</h5>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="card mt-2">
                            <div class="card-body">
                                <h4 class="azul"><b>Seleccionar período de matrícula</b></h4>
                                <hr class="azul">
                                <br>

                                <div class="row align-items-center">
                                    <label for="" class="col-md-1">Sede:</label>
                                    <div class="col-md-3">
                                        <ng-select [items]="sedes" bindLabel="M05DES" (change)="cambioSede()" [(ngModel)]="sedeSeleccionada">
                                           
                                        </ng-select>
                                    </div>
                                    <label for="" class="col-md-1">Período de matrícula activo:</label>
                                    <div class="col-md-3">
                                        <ng-select [items]="periodos" bindLabel="M19DES" (change)="cambioPeriodo()" [(ngModel)]="periodoSeleccionado">   
                                        </ng-select>
                                    </div>
                                    <label for="" class="col-md-1">Carrera:</label>
                                    <div class="col-md-3">
                                        <ng-select [items]="carreras" bindLabel="M02DES" bindValue="M04IUP" [(ngModel)]="M04IUP" (change)="consultarLobby()">
                                            
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body periodo">
                                        <h4 class="azul"><b>Actual período de matrícula</b></h4>
                                        <hr class="azul">

                                        <p><label>Año: </label> 2022</p>
                                        <p><label>Período lectivo: </label> I cuatrimestre</p>
                                        <p><label>Modalidad: </label> Ordinaria</p>
                                        <p><label>Período de matrícula: </label> 04/09/2022 - 04/10/2022</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body periodo">
                                        <h4 class="azul"><b>Cita de Pre-matrícula</b></h4>
                                        <hr class="azul">

                                        <p *ngIf="lobby.CITA_MATRICULA == 'NO'" style="color: red">No es su cita de matrícula aún</p>
                                        <p><label>Día: </label> {{lobby.FECHA_LIMITE}}</p>
                                        <p><label>Hora: </label> </p>
                                    </div>
                                </div>
                            </div>  
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body periodo">
                                        <h4 class="azul"><b>Pendientes con la institución</b></h4>
                                        <hr class="azul">

                                        <p style="color: red" class="mb-3">No puede tener pendientes para poder matricular</p>
                                        <ng-container *ngIf="lobby.REQUISITOS_PENDIENTES.length > 0;else sinRequisitos">
                                            <ul>
                                                <li *ngFor="let requisito of lobby.REQUISITOS_PENDIENTES">
                                                    {{requisito.REQUISITO}}
                                                </li>
                                            </ul>
                                        </ng-container>
                                        <ng-template #sinRequisitos>
                                            <h5 style="color: #74bc1f; margin-top: 2em;"><i class="fa fa-circle-check fa-2xl"></i> No registra pendientes</h5>
                                        </ng-template>

                                    </div>
                                </div>
                            </div> 
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body periodo">
                                        <h4 class="azul"><b>Pendientes Financieros</b></h4>
                                        <hr class="azul">

                                        <p style="color: red" class="mb-3">No puede tener pendientes para poder matricular</p>
                                        <ng-container *ngIf="lobby.DEUDAS.length > 0;else sinDeudas">
                                            <div class="row mt-1" *ngFor="let deuda of lobby.DEUDAS">
                                                <div class="col-md-12">
                                                    <h5 class="azul">{{deuda.CXC21DES}}</h5>
                                                </div>
                                                <div class="col-md-6">
                                                    <p><label>Deuda</label></p>
                                                    <p class="mt-0">{{deuda.CXC21MON}} {{deuda.CNT01COD}}</p>
                                                </div>
                                                <div class="col-md-6">
                                                    <p><label>Fecha de vencimiento</label></p>
                                                    <p class="mt-0">{{deuda.CXC21FVE}}</p>
                                                </div>
                                                <hr>
                                            </div>
                                            
                                        </ng-container>
                                        <ng-template #sinDeudas>
                                            <h5 style="color: #74bc1f; margin-top: 2em;"><i class="fa fa-circle-check fa-2xl"></i> No registra pendientes</h5>
                                        </ng-template>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body periodo">
                                        <h4 class="azul"><b>Becas</b></h4>
                                        <hr class="azul">

                                        <ng-container *ngIf="lobby.BECA != '';else sinBeca">
                                            <h4 class="mb-0">{{lobby.BECA}}</h4>
                                            <h5 style="color: #74bc1f">Aprobada</h5>
                                        </ng-container>
                                        <ng-template #sinBeca>
                                            <h5>No registra becas</h5>
                                        </ng-template>
                                    </div>
                                </div>
                            </div> 
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="card-body periodo">
                                        <h4 class="azul"><b>Financiamientos</b></h4>
                                        <hr class="azul">

                                        <ng-container *ngIf="lobby.TIENE_FINANCIAMIENTO != 'NO';else sinFinanciamiento">
                                            <h4 class="mb-0">{{lobby.FINANCIAMIENTO}}</h4>
                                            <h5 style="color: #74bc1f">Aprobada</h5>
                                        </ng-container>
                                        <ng-template #sinFinanciamiento>
                                            <h5>No registra financiamientos</h5>
                                        </ng-template>
                                    </div>
                                </div> 
                            </div>

                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body periodo">
                                        <h4 class="azul"><b>Próximos períodos de matrícula</b></h4>
                                        <hr class="azul">

                                        <div class="row">
                                            <div class="col-md-12">
                                                <h5 class="azul">Métodos y técnicas de estudio</h5>
                                            </div>
                                            <div class="col-md-6">
                                                <p><label>Período: </label> Semestre ordinario</p>
                                                <p class="mt-0">Del 03 al 05 de julio de 2022</p>
                                            </div>
                                            <div class="col-md-6">
                                                <p><label>Cita de la matrícula</label></p>
                                                <p class="mt-0">Del 03 al 05 de julio de 2022</p>
                                            </div>
                                        </div>
                                        <hr>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <h5 class="azul">Teoría de la comunicación</h5>
                                            </div>
                                            <div class="col-md-6">
                                                <p><label>Período: </label> Semestre ordinario</p>
                                                <p class="mt-0">Del 03 al 05 de julio de 2022</p>
                                            </div>
                                            <div class="col-md-6">
                                                <p><label>Cita de la matrícula</label></p>
                                                <p class="mt-0">Del 03 al 05 de julio de 2022</p>
                                            </div>
                                        </div>
                                        <hr style="height: 2px;">

                                        <div class="row">
                                            <div class="col-md-12">
                                                <h5 class="azul">Ciencias naturales I</h5>
                                            </div>
                                            <div class="col-md-6">
                                                <p><label>Período: </label> Semestre ordinario</p>
                                                <p class="mt-0">Del 03 al 05 de julio de 2022</p>
                                            </div>
                                            <div class="col-md-6">
                                                <p><label>Cita de la matrícula</label></p>
                                                <p class="mt-0">Del 03 al 05 de julio de 2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> 
                        </div>

                        <div class="row gx-2" style="text-align: right">
                            <div class="col-md-2 offset-md-6">
                                <button type="button" style="width: 100%"
                                    class="btn btn-sm btn-secondary w-100">Cancelar</button>
                            </div>
                            <div class="col-md-2">
                                <button type="button" (click)="tabAtras()"
                                    class="btn btn-sm btn-secondary w-100">Regresar</button>
                            </div>
                            <div class="col-md-2">
                                <button type="button" (click)="tabAdelante()"
                                    class="btn btn-sm btn-info w-100">Continuar</button>
                            </div>
                        </div>
                            
                    </ng-template>
                </li>
                <li [ngbNavItem]="3">
                    <a ngbNavLink class="itemTab"
                        style="clip-path: polygon(0% 0%,80% 0%,100% 50%,80% 100%,0% 100%,20% 50%);
                        margin-left:-25%">
                        <h5 style="padding-left: 20%">Elegir grupos a Pre-Matricular</h5>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="mt-3">
                        <div ngbAccordion #acc="ngbAccordion">
                            <div ngbAccordionItem id="panel-1">
                                <h2 ngbAccordionHeader>
                                    <button class="azul" ngbAccordionButton><b>Calendario Semanal</b></button>
                                </h2>
                                <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                        <ng-template>
                                            <full-calendar [options]='calendarOptions'></full-calendar>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <div ngbAccordionItem id="panel-2">
                                <h2 ngbAccordionHeader>
                                    <button class="azul" ngbAccordionButton><b>Materias y Grupos disponibes</b></button>
                                </h2>
                                <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                        <ng-template>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <h5 class="azul"><b>Materias disponibles</b></h5>
                                                            <hr class="azul">
                    
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <td>Nombre del curso</td>
                                                                        <td>Código</td>
                                                                        <td>Créditos</td>
                                                                        <td>Grupos</td>
                                                                    </tr>
                                                                </thead>
                                                                <ng-container *ngIf="materias.length > 0;else sinmaterias">
                                                                    <ng-container *ngFor="let materia of materias">
                                                                        <tr *ngIf="materia.PREMATRICULADA == ''">
                                                                            <td>
                                                                                <div style="display: flex">
                                                                                    <input type="radio" name="materia" (change)="seleccionMateria(materia)">  
                                                                                    <b class="azul" style="margin-left: 0.5em">{{materia.M11DES}}</b>
                                                                                </div>
                                                                            </td>
                                                                            <td>{{materia.M11COD}}</td>
                                                                            <td>{{materia.M11CRED}}</td>
                                                                            <td>{{materia.TOTAL_GRUPOS}}</td>
                                                                        </tr>
                                                                    </ng-container>   
                                                                </ng-container>
                                                                <ng-template #sinmaterias>
                                                                    <tr>
                                                                        <td colspan="4">No hay materias disponibles</td>
                                                                    </tr>
                                                                </ng-template>  
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <h5 class="azul" *ngIf="materiaSeleccionada!=null;else sinmateria"><b>Grupos disponibles:</b> {{materiaSeleccionada.M11DES}}</h5>
                                                            <ng-template #sinmateria>
                                                                <h5 class="azul"><b>Grupos disponibles:</b> </h5>
                                                            </ng-template>
                                                            <hr class="azul">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <td>Sede</td>
                                                                        <td>Grupo</td>
                                                                        <td>Profesor</td>
                                                                        <td>Horario</td>
                                                                        <td>Modo</td>
                                                                        <td>Cupos</td>
                                                                    </tr>
                                                                </thead>
                                                                <ng-container *ngIf="grupos.length > 0;else singrupos">
                                                                    <tr *ngFor="let grupo of grupos">
                                                                        <td>
                                                                            <div style="display: flex">
                                                                                <button class="btn" (click)="prematricularMateria(grupo)" data-toggle="tooltip" data-placement="top" title="Matricular"
                                                                                    style="background-color: gainsboro; border-radius: 50px">
                                                                                    <i style="color: #121281" class="fa fa-user-plus fa-2xl"></i>
                                                                                </button> 
                                                                                <span style="margin-left: 0.5em">{{sedeSeleccionada.M05DES}}</span> 
                                                                            </div>                                     
                                                                        </td>
                                                                        <td>{{grupo.M23GRU}}</td>
                                                                        <td>
                                                                            <div [ngbTooltip]="foto" placement="top" (mouseenter)="cambiarImagen(grupo.IMAGEN)">
                                                                                {{grupo.M26NOM}}
                                                                            </div>
                                                                        </td>
                                                                        <td style="white-space: pre-line">{{formatoHorario(grupo.HORARIO)}}</td>
                                                                        <td>{{grupo.E05DES}}</td>
                                                                        <td>{{grupo.CUPO}}</td>
                                                                    </tr>
                                                                </ng-container>
                                                                <ng-template #singrupos>
                                                                    <tr>
                                                                        <td colspan="6">Selecciona una matería para ver sus grupos disponibles</td>
                                                                    </tr>
                                                                </ng-template>
                                                        </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                            <div ngbAccordionItem id="panel-3">
                                <h2 ngbAccordionHeader>
                                    <button class="azul" ngbAccordionButton><b>Materias Matriculadas</b></button>
                                </h2>
                                <div ngbAccordionCollapse>
                                    <div ngbAccordionBody>
                                        <ng-template>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <td>Nombre del curso</td>
                                                                        <td>Código</td>
                                                                        <td>Créditos</td>
                                                                        <td>Sede</td>
                                                                        <td>Grupo</td>
                                                                        <td>Profesor</td>
                                                                        <td>Horario</td>
                                                                        <td>Modo</td>
                                                                        <td>Matriculados</td>
                                                                    </tr>
                                                                </thead>
                                                                <ng-container *ngIf="prematriculadas.length;else sinmatriculadas">
                                                                    <tr *ngFor="let prematriculada of prematriculadas">
                                                                        <td>
                                                                            <div style="display: flex">
                                                                                <button class="btn" data-toggle="tooltip" data-placement="top" title="Eliminar" (click)="eliminarPrematricula(prematriculada.materia.M11COD, prematriculada.grupo.M23GRU)"
                                                                                    style="background-color: gainsboro; border-radius: 50px">
                                                                                    <i style="color: red" class="fa fa-user-minus fa-2xl"></i>
                                                                                </button> 
                                                                                <span style="margin-left: 0.5em">{{prematriculada.materia.M11DES}}</span> 
                                                                            </div>   
                                                                        </td>
                                                                        <td>{{prematriculada.materia.M11COD}}</td>
                                                                        <td>{{prematriculada.materia.M11CRED}}</td>
                                                                        <td>{{sedeSeleccionada.M05DES}}</td>
                                                                        <td>{{prematriculada.grupo.M23GRU}}</td>
                                                                        <td>{{prematriculada.grupo.M26NOM}}</td>
                                                                        <td style="white-space: pre-line">{{formatoHorario(prematriculada.grupo.HORARIO)}}</td>
                                                                        <td>{{prematriculada.grupo.E05DES}}</td>
                                                                        <td></td>
                                                                    </tr>
                                                                </ng-container>
                                                                <ng-template #sinmatriculadas>
                                                                    <tr>
                                                                        <td colspan="9">Sin materías prematriculadas</td>
                                                                    </tr>
                                                                </ng-template>
                                                            </table>
                                                            <div class="row mt-3">
                                                                <div class="col-md-3 offset-md-9">
                                                                    <button type="button" class="btn btn-sm btn-info w-100" (click)="confirmarPrematricula()">Guardar Selección</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row gx-2 mt-3" style="text-align: right">
                            <div class="col-md-2 offset-md-6">
                                <button type="button" style="width: 100%"
                                    class="btn btn-sm btn-secondary w-100">Cancelar</button>
                            </div>
                            <div class="col-md-2">
                                <button type="button" (click)="tabAtras()"
                                    class="btn btn-sm btn-secondary w-100">Regresar</button>
                            </div>
                            <div class="col-md-2">
                                <button type="button" (click)="tabAdelante()"
                                    class="btn btn-sm btn-info w-100">Continuar</button>
                            </div>
                        </div>
                    </div>
                </ng-template>
                </li>
                <li [ngbNavItem]="4">
                    <a ngbNavLink class="itemTab" style="clip-path: polygon(0% 0%,100% 0%,100% 100%,0% 100%,20% 50%);
                        margin-left:-25%">
                        <h5 style="padding-left: 20%">Confirmar</h5>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="row mt-2">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <h4 class="azul"><b>Materias elegidas para prematricular</b></h4>
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <td>Nombre del curso</td>
                                                    <td>Código</td>
                                                    <td>Créditos</td>
                                                    <td>Sede</td>
                                                    <td>Grupo</td>
                                                    <td>Profesor</td>
                                                    <td>Horario</td>
                                                    <td>Modo</td>
                                                    <td>Matriculados</td>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let prematriculada of prematriculadas">
                                                <td>
                                                    <div style="display: flex">
                                                        <button class="btn" data-toggle="tooltip" data-placement="top" title="Eliminar" (click)="eliminarPrematricula(prematriculada.materia.M11COD, prematriculada.grupo.M23GRU)"
                                                            style="background-color: gainsboro; border-radius: 50px">
                                                            <i style="color: red" class="fa fa-user-minus fa-2xl"></i>
                                                        </button> 
                                                        <span style="margin-left: 0.5em">{{prematriculada.materia.M11DES}}</span> 
                                                    </div>   
                                                </td>
                                                <td>{{prematriculada.materia.M11COD}}</td>
                                                <td>{{prematriculada.materia.M11CRED}}</td>
                                                <td>{{sedeSeleccionada.M05DES}}</td>
                                                <td>{{prematriculada.grupo.M23GRU}}</td>
                                                <td>{{prematriculada.grupo.M26NOM}}</td>
                                                <td style="white-space: pre-line">{{formatoHorario(prematriculada.grupo.HORARIO)}}</td>
                                                <td>{{prematriculada.grupo.E05DES}}</td>
                                                <td></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="row">
                                            <h4 class="azul col-md-3"><b>Montos a Cancelar</b></h4>
                                            <div class="col-md-9">
                                                <p>{{confirmacion.MENSAJE}}</p>
                                            </div>
                                        </div>
                                        <hr class="azul">

                                        <div class="row">
                                            <div class="offset-md-8 col-md-4">
                                                <div class="mb-0">
                                                    <h5 class="mb-0"><b class="azul">Condición especial de financiamiento:</b></h5>
                                                    <ng-select [items]="financiamientos" bindLabel="F08DES" (change)="cambiarFinanciamiento($event)">
                                                        
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <table class="table no-hover tbcostos">
                                                   
                                                    <tbody>
                                                        <tr class="subtitulo azul">
                                                            <td>Descripción</td>
                                                            <td>Créditos</td>
                                                            <td>{{confirmacion.ENCABEZADO.COLEGIATURA | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr *ngFor="let detalle of confirmacion.DETALLE">
                                                            <td>{{detalle.M54DES}}</td>
                                                            <td>{{detalle.M11CRED}}</td>
                                                            <td>{{detalle.M54MON | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr class="subtitulo azul">
                                                            <td colspan="2">Cobros</td>
                                                            <td>{{confirmacion.ENCABEZADO.SUBTOTAL | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Matrícula</td>
                                                            <td></td>
                                                            <td>{{confirmacion.ENCABEZADO.MATRICULA | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Colegiatura</td>
                                                            <td></td>
                                                            <td>{{confirmacion.ENCABEZADO.COLEGIATURA | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Otros</td>
                                                            <td></td>
                                                            <td>{{confirmacion.ENCABEZADO.OTROS | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr class="subtitulo azul">
                                                            <td colspan="2">Incentivos</td>
                                                            <td>{{(confirmacion.ENCABEZADO.BECAS*1) + (confirmacion.ENCABEZADO.DESCUENTOS*1) | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Becas</td>
                                                            <td></td>
                                                            <td>{{confirmacion.ENCABEZADO.BECAS | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Descuentos</td>
                                                            <td></td>
                                                            <td>{{confirmacion.ENCABEZADO.DESCUENTOS | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr class="subtitulo azul">
                                                            <td colspan="2">Subtotal</td>
                                                            <td>{{confirmacion.ENCABEZADO.SUBTOTAL | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Impuestos</td>
                                                            <td></td>
                                                            <td>{{confirmacion.ENCABEZADO.IMPUESTOS | number: '1.2-2'}}</td>
                                                        </tr>
                                                        <tr class="subtitulo azul">
                                                            <td colspan="2">Total a pagar</td>
                                                            <td>{{confirmacion.ENCABEZADO.TOTAL | number: '1.2-2'}}</td>
                                                        </tr>                                     
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div class="text-center mt-3">
                                                <h5 style="color: black">Notas Aclaratorias</h5>
                                            </div>
                                            <hr>

                                            <ol>
                                                <li>Nos reservamos el derecho a  modificar la oferta</li>
                                                <li>La matrícula de las materias inscritas quedará en firme hasta el momento que se emita el recibo de dinero, mismo que
                                                    estará acorde al compromiso financiero adquirido previamente con la institución
                                                </li>
                                                <li>Se le recuerda que el INFORME DE PREMATRICULA será anulada 24 horas después que haya sido formalizada en el sistema,
                                                     siempre y cuando esta NO se encuentre debidamente cancelada por el medio de pago de su elección
                                                </li>
                                            </ol>

        
                                            <div class="mt-3 row gx-2" style="text-align: right">
                                                <div class="col-md-2 offset-md-5">
                                                    <button type="button" style="width: 100%"
                                                        class="btn btn-sm btn-secondary w-100">Cancelar</button>
                                                </div>
                                                <div class="col-md-2">
                                                    <button type="button" (click)="tabAtras()"
                                                        class="btn btn-sm btn-secondary w-100">Regresar</button>
                                                </div>
                                                <div class="col-md-3">
                                                    <button type="button" (click)="autenticar()"
                                                        class="btn btn-sm btn-info w-100">Confirmar y cancelar
                                                        deuda</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>
            <div [ngbNavOutlet]="nav"></div>
        </div>
    </div>
</div>

<ng-template #modalFormalizar let-modal>
    <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
    <div class="modal-header" style="background-color: var(--app-primario, #1392c7)">
        <h4 class="modal-title w-100 text-center" style="color: white">Generación de Autenticación Trámite</h4>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-2">
                <img src="assets/images/Icon_Alerta-InformacionAvatar-SyS.png" height="181" alt="info">
            </div>
            <div class="col-10">
                <div class="row">
                    <div class="col-md-12">
                        <p>Si usted ha leído y validado el contenido de la boleta de pre matrícula, por favor proceda
                            con los siguientes pasos:</p>
                        <ol>
                            <li> Digitar la contraseña que utiliza para ingresar al sistema AVATAR.</li>
                            <li> Luego presione en el botón de Autenticar Trámite</li>
                            <li> Por último, presione en el botón de Formalizar Boleta</li>
                        </ol>
                    </div>
                </div>
                <br>
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <label for="password">Contraseña:</label>
                        <input type="password" class="form-control"  [(ngModel)]="password">
                    </div>
                    <div class="col-md-6">
                        <br>
                        <button type="button" class="btn btn-primary" (click)="autenticarTramite()">Autenticar Trámite</button>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-md-12">
                        <label for="password">Clave autenticación solicitada:</label>
                        <div class="rounded" style="background-color: #c1bfbf; min-height: 3em; text-align: center; padding-top: 1em; padding-bottom: 1em;">{{token}}</div>
                        <br>

                        <div class="text-center mt-2 mb-2">
                            <button type="button" class="btn btn-primary" (click)="formalizarBoleta()">Formalizar Boleta</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #foto>
    <div style="background-color: white; 
    width: 100%;
    border: 1px solid black;">
        <img [src]="strImg" (error)="imagenFalla()" alt="foto" style="width: 200px">
    </div>
</ng-template>

<div style="display: none" id="html-alerta">
    <div class="swal-alerta">
        <div class="row">
            <div class="col-md-12 text-center">
                <h4 id="alerta-titulo"></h4>
                <hr>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-4">
                <img id="alerta-imagen" src="" alt="Alerta" style="width: 100%">
            </div>
            <div class="col-md-8">
                <h5 id="alerta-mensaje" style="text-align: left"></h5>
            </div>
        </div>
    </div>
</div>